import { Helmet } from "react-helmet-async";
import ContractsAICard from "../../../components/dashboard/contracts/ContractsAICard";

export default function ContractsAITool() {
  return <>
    <Helmet>
      <title>Contracts | Platform Solutions</title>
    </Helmet>

    <ContractsAICard />
 </>;
}
